import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString1pkumu07cwy4m as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SocketOverloadClass;
function SocketOverload() {
  if (SocketOverloadClass === VOID) {
    class $ extends CacheUpdate() {
      oej() {
        return null;
      }
      toString() {
        return 'SocketOverload(' + toString(this.oej()) + ')';
      }
    }
    initMetadataForClass($, 'SocketOverload', SocketOverload);
    SocketOverloadClass = $;
  }
  return SocketOverloadClass;
}
var SocketChangesClass;
function SocketChanges() {
  if (SocketChangesClass === VOID) {
    class $ extends CacheUpdate() {
      constructor(changed, removed, fromCondition, fromRequirements) {
        super();
        this.pej_1 = changed;
        this.qej_1 = removed;
        this.rej_1 = fromCondition;
        this.sej_1 = fromRequirements;
      }
      oej() {
        return this.pej_1;
      }
      toString() {
        return 'SocketChanges(' + toString_0(this.pej_1) + ', ' + toString_0(this.qej_1) + ', ' + toString_0(this.rej_1) + ', ' + toString_0(this.sej_1) + ')';
      }
    }
    initMetadataForClass($, 'SocketChanges');
    SocketChangesClass = $;
  }
  return SocketChangesClass;
}
var QueryResultClass;
function QueryResult() {
  if (QueryResultClass === VOID) {
    class $ extends CacheUpdate() {
      constructor(query, result) {
        super();
        this.tej_1 = query;
        this.uej_1 = result;
      }
      oej() {
        return this.uej_1;
      }
      toString() {
        return 'QueryResult(' + this.tej_1.toString() + ', ' + toString_0(this.uej_1) + ')';
      }
    }
    initMetadataForClass($, 'QueryResult');
    QueryResultClass = $;
  }
  return QueryResultClass;
}
var MultiGetResultClass;
function MultiGetResult() {
  if (MultiGetResultClass === VOID) {
    class $ extends CacheUpdate() {
      constructor(missing, result) {
        super();
        this.vej_1 = missing;
        this.wej_1 = result;
      }
      oej() {
        return this.wej_1;
      }
      toString() {
        return 'MultiGetResult(' + toString_0(this.vej_1) + ', ' + toString_0(this.wej_1) + ')';
      }
    }
    initMetadataForClass($, 'MultiGetResult');
    MultiGetResultClass = $;
  }
  return MultiGetResultClass;
}
var MutationResultClass;
function MutationResult() {
  if (MutationResultClass === VOID) {
    class $ extends CacheUpdate() {
      constructor(items) {
        super();
        this.xej_1 = items;
      }
      oej() {
        return this.xej_1;
      }
      toString() {
        return 'MutationResult(' + toString_0(this.xej_1) + ')';
      }
    }
    initMetadataForClass($, 'MutationResult');
    MutationResultClass = $;
  }
  return MutationResultClass;
}
var DeletionResultClass;
function DeletionResult() {
  if (DeletionResultClass === VOID) {
    class $ extends CacheUpdate() {
      constructor(deletedIds) {
        super();
        this.yej_1 = deletedIds;
        var tmp = this;
        // Inline function 'kotlin.collections.listOf' call
        tmp.zej_1 = emptyList();
      }
      oej() {
        return this.zej_1;
      }
      toString() {
        return 'DeletionResult(' + toString_0(this.yej_1) + ')';
      }
    }
    initMetadataForClass($, 'DeletionResult');
    DeletionResultClass = $;
  }
  return DeletionResultClass;
}
var CacheUpdateClass;
function CacheUpdate() {
  if (CacheUpdateClass === VOID) {
    class $ {}
    initMetadataForClass($, 'CacheUpdate');
    CacheUpdateClass = $;
  }
  return CacheUpdateClass;
}
//region block: exports
export {
  DeletionResult as DeletionResultccwd2e565l92,
  MultiGetResult as MultiGetResults6dlyquirmyb,
  MutationResult as MutationResultxmj9lk13qzu5,
  QueryResult as QueryResult2ufeva9wjs3uo,
  SocketChanges as SocketChanges3116hd430s44s,
  SocketOverload as SocketOverload2oan4qiwxidew,
};
//endregion

//# sourceMappingURL=CacheUpdate.mjs.map
